import { render } from "./ProfileFormWork.vue?vue&type=template&id=42e4c16c&scoped=true"
import script from "./ProfileFormWork.vue?vue&type=script&lang=js"
export * from "./ProfileFormWork.vue?vue&type=script&lang=js"

import "./ProfileFormWork.vue?vue&type=style&index=0&id=42e4c16c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42e4c16c"]])

export default __exports__